import { WebhookConfigurationEditRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit',
)({
  component: WebhookConfigurationEditRoute,
});
